<p-overlayPanel #panel [dismissable]="true" styleClass="stupa-legend-panel">
  <ul class="stupa-legend-list">
    @for (item of items; track item.abbr) {
      <li class="stupa-legend-row">
        <span class="stupa-legend-abbr">{{ item.abbr }}</span>
        <span class="stupa-legend-full">{{ item.full }}</span>
      </li>
    }
  </ul>
</p-overlayPanel>
